import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form, Button, Card } from "antd";
import Modal from "react-bootstrap/Modal";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import AndtDPasswordBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/PasswordBoxWrapper";
import { strongPasswordValidator } from "../../validators";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import AuthDataProvider from "../../AuthDataProvider";
import { URLS, validator_messages } from "../../constants";
import { NOTIFICATIONS } from "../../../LandingPage/constants";
import { ErrorLogger } from "../../../App/Utils/ErrorHandler";

class ChangePassword extends Component {
  formRef = React.createRef();
  DataProvider = new AuthDataProvider();

  state = {
    isLoading: false,
  };

  onFinish = (values) => {
    if (values["npassword"] !== values["cpassword"]) {
      openNotification(
        openNotificationType.error,
        notificationTitle.form,
        validator_messages.CONFIRM_PASSWORD
      );
    } else {
      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim())
      });
      this.changePassword(values);
    }
  };

  changePassword = (values) => {
    try {
      values.opassword = values.opassword.trim();
      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.CHANGE_PASSWORD}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              Object.keys(res).map((success) => {
                openNotification(
                  openNotificationType.success,
                  success,
                  res[success]
                );
              });

              this.formRef.current.resetFields();
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  render() {
    return (
      <>
        <Modal show={this.state.isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <Form
          onFinish={this.onFinish}
          layout="vertical"
          ref={this.formRef}
          className="container_bg text-center"
          autoComplete="off"
        >
          <Card title="Change Password" className="main_card p-1">
            <div className="col-lg-12 col-md-12">
              <AndtDPasswordBoxWrapper
                decorator="opassword"
                id="OPassword"
                required="true"
                label="Old Password"
                message="Enter Old Password"
                placeholder="Enter Old Password"
                validators=""
                // validators={[{ validator: strongPasswordValidator }]}
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12">
              <AndtDPasswordBoxWrapper
                decorator="npassword"
                id="NPassword"
                required="true"
                label="New Password"
                message="Enter New Password"
                placeholder="Enter New Password"
                // validators=""
                validators={[{ validator: strongPasswordValidator }]}
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12">
              <AndtDPasswordBoxWrapper
                decorator="cpassword"
                id="CPassword"
                required="true"
                label="Confirm Password"
                message="Enter Confirm Password"
                placeholder="Enter Confirm Password"
                validators=""
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12 text-center">
              <Button htmlType="submit" type="primary" id="changepass">
                Change Password
              </Button>
            </div>
          </Card>
        </Form>
        <br />
        <br />
        <br />
      </>
    );
  }
}

export default withRouter(ChangePassword);
